const React = require('react');

class TableNav extends React.Component {
  disableButton(link) {
    return !link;
  }

  render() {
    if (!this.props.nextLink && !this.props.prevLink) { return false; }
    return (
      <nav className="table-nav">
        <button
          className="btn btn-small btn-secondary"
          title={I18n.t('js.previous')}
          onClick={this.props.onPrevClick}
          disabled={this.disableButton(this.props.prevLink)}
        >
          <i className="fa fa-chevron-left"></i>
        </button>

        <button
          className="btn btn-small btn-secondary"
          title={I18n.t('js.next')}
          onClick={this.props.onNextClick}
          disabled={this.disableButton(this.props.nextLink)}
        >
          <i className="fa fa-chevron-right"></i>
        </button>
      </nav>
    );
  }
}

TableNav.propTypes = {
  nextLink: React.PropTypes.object,
  prevLink: React.PropTypes.object,
  onPrevClick: React.PropTypes.func,
  onNextClick: React.PropTypes.func,
};

module.exports = TableNav;



// WEBPACK FOOTER //
// ./javascripts/components/price_guide/transaction_history/table/nav.jsx